import React from 'react';
import PropTypes from 'prop-types';

const SegmentedControl = ({ options, value, onChange, className = '' }) => {
  // Determine grid column class based on number of options
  const gridColsClass = `grid-cols-${options.length}`;

  return (
    // Changed from flex to grid, added dynamic grid-cols, added gap
    <div className={`grid ${gridColsClass} gap-1 bg-hooray-beige-60 rounded-lg p-1 ${className}`}>
      {options.map((option) => {
        const isActive = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            // Changed text size/weight from text-sm font-medium to text-base font-bold
            className={`justify-center text-center px-9 py-2.5 rounded-md text-base font-bold transition-colors duration-200 font-mont ${
              isActive
                ? 'bg-hooray-red text-hooray-yellow shadow-sm' // Active state
                // Updated inactive state to match secondary button style
                : 'bg-white border border-hooray-red text-hooray-red hover:bg-hooray-red hover:text-white' 
            }`}
            aria-pressed={isActive}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

SegmentedControl.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default SegmentedControl; 